import { getStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export default function isSharedMailbox(mailboxInfo: MailboxInfo): boolean {
    return getStore(mailboxInfo).isSharedMailbox;
}
